module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/codebuild-2016-10-06.paginators.json
// module id = 314
// module chunks = 1